export const PAGE_SIZE = 10;

export default function getPaginationParams(page_number: number = 1): string {
    return `limit=${PAGE_SIZE}&offset=${(page_number - 1) * PAGE_SIZE}`
}